import { Injectable, Injector } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {

  constructor(
    private title: Title,
    private injector: Injector,
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title) {
      const section = _.toUpper(routerState.url.split('/')[1]);
      this.title.setTitle(`${this.injector.get(TranslateService).instant(title)} - ${section}`);
    }
  }
}